export default __webpack_public_path__ + "static/media/53.034485e6.jpeg";